import Vue from 'vue'
import GlobalStore from './Global.store';

export const BASE_URL = 'https://vpn.drmg.com:9001/v1';
const CRM_PAGE = '/users/crm';

let localStorage = window.localStorage;

const initUser = {
  username: null,
  password: null,
  token: null,
  passwordExpired: false,
  UserListOperations: []
}

export default {
  data() {
    return {
      api: null,
      user: this.CRM_getUserFromStorage(),
      global: GlobalStore,
    }
  },
  computed: {
    isPartnerUser() {
      return this.global.insightUser.admin === 4;
    },
  },
  created: function () {
    let self = this;
    this.api = Vue.axios.create({
      baseURL: BASE_URL,
      // timeout: 1000,
      // headers: {'X-Custom-Header': 'foobar'}
    });

    // logout and redirect to login if not logged in
    if (self.user.token == null && window.location.href.indexOf('users/login') == -1 && window.location.href.indexOf(CRM_PAGE) == -1) {
      self.CRM_redirectToLogin();
    }

    this.api.interceptors.request.use(function(config) {
      // logout and redirect to login if trying to use api while not logged in
      if (self.user.token == null && config.url.indexOf('users/login') == -1 && window.location.href.indexOf(CRM_PAGE) == -1) {
        self.CRM_redirectToLogin();
      }
      // add auth token to all requests
      if (self.user.token) {
        config.headers.Authorization = self.user.token;
      }
      return config;
    }, function (error) {
      // Do something with request error
      return Promise.reject(error);
    });
    this.api.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      // logout and redirect to login if received 401 response from any endpoint except login
      if (error.response.status === 401 && error.response.config.url.indexOf('users/login') === -1) {
        self.CRM_redirectToLogin();
      }
      // Do something with response error
      return Promise.reject(error);
    });
  },
  methods: {
    CRM_save(data) {
      this.user = data;
      localStorage.setItem('CRM', JSON.stringify(data));
    },
    CRM_getUserFromStorage() {
      const data = localStorage.getItem('CRM');
      if (!data) return initUser;
      try {
        const parsed = JSON.parse(data);
        if (!parsed.token) {
          localStorage.removeItem('CRM');
          return initUser;
        }
        return parsed;
      } catch(error) {
        console.error(error);
        localStorage.removeItem('CRM');
        return initUser;
      }
    },
    CRM_redirectToLogin() {
      let self = this;
      // if partner user, do not redirect to CRM login
      if (self.isPartnerUser) {
        return;
      }
      self.CRM_logout();
      window.location.replace(CRM_PAGE);
      return;
    },
    CRM_login(username, password) {
      let data = { username, password }
      return this.api.post('users/login', data);
    },
    CRM_logout() {
      this.user = initUser;
      localStorage.removeItem('CRM');
    },
    CRM_clientSearch(query) {
      const data = {
        CompanyName: query,
        Stage: 'P'
      }
      return this.api.post('contacts/clients_search', data);
    },
    CRM_getClient(id) {
      return this.api.get('contacts/' + id + '?related=rep,supervisor');
    }
  }
}



// WEBPACK FOOTER //
// ./src/CRM.js